// extracted by mini-css-extract-plugin
module.exports = {"painManagement":"PainManagement_painManagement__2y9UJ","painFooter":"PainManagement_painFooter__2pfCt","link":"PainManagement_link__20TkX"};